import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "25",
  viewBox: "0 0 24 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("g", null, [
        _createElementVNode("g", null, [
          _createElementVNode("g", null, [
            _createElementVNode("path", {
              fill: "#FFF",
              d: "M3 14.25l.102.007c.366.05.648.363.648.743v5.25H9l.102.007c.366.05.648.363.648.743 0 .414-.336.75-.75.75H3l-.102-.007c-.366-.05-.648-.363-.648-.743v-6l.007-.102c.05-.366.363-.648.743-.648zm18 0c.38 0 .693.282.743.648l.007.102v6c0 .38-.282.693-.648.743L21 21.75h-6c-.414 0-.75-.336-.75-.75 0-.38.282-.693.648-.743L15 20.25h5.25V15c0-.38.282-.693.648-.743L21 14.25zm-2.75-2.75c.414 0 .75.336.75.75 0 .38-.282.693-.648.743L18.25 13h-12c-.414 0-.75-.336-.75-.75 0-.38.282-.693.648-.743l.102-.007h12zM9 2.25c.414 0 .75.336.75.75 0 .38-.282.693-.648.743L9 3.75H3.75V9c0 .38-.282.693-.648.743L3 9.75c-.38 0-.693-.282-.743-.648L2.25 9V3c0-.38.282-.693.648-.743L3 2.25h6zm12 0l.102.007c.366.05.648.363.648.743v6l-.007.102c-.05.366-.363.648-.743.648l-.102-.007c-.366-.05-.648-.363-.648-.743V3.75H15l-.102-.007c-.366-.05-.648-.363-.648-.743 0-.414.336-.75.75-.75h6z",
              transform: "translate(-1076 -116) translate(1072 112) translate(4 4)"
            })
          ])
        ])
      ])
    ], -1)
  ]))]))
}
export default { render: render }